module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footerbig"
  }, [_c('div', {
    staticClass: "footerbox mt40"
  }, [_c('p', {
    staticClass: "tc f14"
  }, [_vm._v("\n             主办单位：人力资源和社会保障部人事司、人力资源和社会保障部教育培训中心    技术支持：中国创联教育集团\n        ")]), _vm._v(" "), _c('p', {
    staticClass: "tc f14"
  }, [_c('img', {
    staticClass: "mr5",
    attrs: {
      "src": "/static/images/bq-icon_06.png"
    }
  }), _vm._v("京公网安备 11010102002485号   京ICP：备11042657号    人力资源和社会保障部教育培训中心网站\n        ")]), _vm._v(" "), _c('p', {
    staticClass: "tc f14"
  }, [_vm._v("\n            Copyright2017. All right reserved edu.mohrss.gov.cn\n        ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-3b21b0be"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/views/Footer.vue
// module id = 1143
// module chunks = 41